import React from 'react';
import { Button } from 'antd';
import { Download, FileDown, ShieldCheck } from 'lucide-react';
import * as S from '../styled';

type Props = {
    tabLabel: string;
    disabled?: boolean;
    loading?: boolean;
    onGenerate: () => void;
};

export function ExportPanel({
    tabLabel,
    disabled,
    loading,
    onGenerate,
}: Props) {
    return (
        <S.ExportCard>
            <S.ExportIcon>
                <FileDown size={24} />
            </S.ExportIcon>
            <S.ExportInfo>
                <S.ExportTitle>Exportar em Excel</S.ExportTitle>
                <S.ExportSubtitle>
                    <ShieldCheck size={15} />
                    Exportando a aba {tabLabel} com os filtros ativos
                </S.ExportSubtitle>
            </S.ExportInfo>
            <Button
                type="primary"
                size="large"
                className="green-btn"
                style={{ width: 'auto' }}
                icon={<Download size={18} />}
                disabled={disabled}
                loading={loading}
                onClick={onGenerate}
            >
                Exportar relatório
            </Button>
        </S.ExportCard>
    );
}
